import { StepImpl } from './step-impl';

export class DummyStep extends StepImpl {
  constructor() {
    super('', '');
  }
}
